// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5g-5";
export var imageContainer = "_5g-4";
export var metricsGrid = "_5g-2";
export var productDetailContainer = "_5g-1";
export var productListContainer = "_5g-0";
export var subscriberTableContainer = "_5g-3";